import { render, staticRenderFns } from "./product-card-history.vue?vue&type=template&id=24cd3d0a&scoped=true&"
import script from "./product-card-history.vue?vue&type=script&lang=js&"
export * from "./product-card-history.vue?vue&type=script&lang=js&"
import style0 from "./product-card-history.vue?vue&type=style&index=0&id=24cd3d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd3d0a",
  null
  
)

export default component.exports